<template  lang="pug">
  .market-audit-result
    template(v-if="hasMarket")
      el-row
        el-col(:span="4")
          span(style="display: inline-block; width: 110px") {{ $t('负责人审核结果') }}
        el-col(:span="20")
          span(style="margin-right: 10px") {{ market.status === 1 ? $t('通过') : $t('拒绝') }}
          span ({{ market.date | dateFormatter }})
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="20")
          display-text-container(:text="market.comment")
    template(v-if="hasLv3")
      el-row
        el-col(:span="4")
          span(style="display: inline-block; width: 110px") {{ $t('管理层审核结果') }}
        el-col(:span="20")
          span(style="margin-right: 10px") {{ lv3.status === 1 ? $t('通过') : $t('拒绝') }}
          span ({{ lv3.date | dateFormatter  }})
      el-row
        el-col(:span="4") {{ $t('备注') }}
        el-col(:span="20")
          display-text-container(:text="lv3.comment")
</template>

<script>
import { dateFormatter } from '@/umcc/util'
import DisplayTextContainer from '@/components/DisplayTextContainer'

export default {
  filters: {
    dateFormatter
  },
  components: {
    DisplayTextContainer
  },
  props: {
    market: {
      type: Object,
      default () {
        return null
      }
    },
    lv3: {
      type: Object,
      default () {
        return null
      }
    },
    hasMarket: {
      type: Boolean,
      default () {
        return false
      }
    },
    hasLv3: {
      type: Boolean,
      default () {
        return false
      }
    }
  }
}
</script>

<style lang="stylus">
.market-audit-result
  > div:nth-child(1)
    margin-bottom 20px
  > div
    > span:nth-child(1)
      display inline-block
      margin-right 10px
      width 60px
      text-align right
</style>
